<template>
  <!-- The chat's emoji panel (SPEC §5.6, plan 2026-11-02-chat-emoji-voice.md): one row of quick
       phrases (scrolls sideways when wider than the panel), the emoji, and a delete key. Each tap
       only puts text into the field; nothing is sent from here. -->
  <div class="chat-emoji-panel" :class="layout" role="group" :aria-label="t('chat-emoji-open')">
    <div class="chat-phrases">
      <button v-for="tag in phrases" :key="tag" type="button" class="chat-phrase" @click="$emit('insert', t(tag))">{{ t(tag) }}</button>
    </div>
    <div class="chat-emoji-grid">
      <button v-for="e in emoji" :key="e" type="button" class="chat-emoji" @click="$emit('insert', e)">{{ e }}</button>
      <button type="button" class="chat-emoji chat-emoji-delete" :aria-label="t('chat-emoji-delete')" :title="t('chat-emoji-delete')" @click="$emit('delete')">⌫</button>
    </div>
  </div>
</template>

<script>
import { t } from '@/texts';

// Unicode 10 (2017) or older and none made of joined parts, so older phones draw them and one
// delete removes one emoji (plan §4.2).
const EMOJI = [
  '😀', '😄', '😂', '🤣', '😊', '😉', '😍', '😎',
  '🤔', '😅', '😭', '😱', '😤', '😴', '🙄', '😏',
  '👍', '👎', '👏', '🙏', '💪', '🤝', '👌', '👋',
  '🎉', '🔥', '💡', '💯', '⏰', '🍵', '🍚',
];

export default {
  name: 'ChatEmojiPanel',
  props: {
    // 'sheet' (phone) or 'panel' (desktop).
    layout: { type: String, required: true },
  },
  data() {
    return { emoji: EMOJI, phrases: ['chat-phrase-1', 'chat-phrase-2', 'chat-phrase-3', 'chat-phrase-4'] };
  },
  methods: { t },
};
</script>

<style scoped>
.chat-emoji-panel {
  flex: none;
  padding: 6px 8px 10px;
  border-top: 1px solid #eee;
  background: #faf7f2;
}

/* One row, always: wider than the panel, it scrolls sideways (owner, 2026-11-02). */
.chat-phrases {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  margin-bottom: 6px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.chat-phrases::-webkit-scrollbar { display: none; }

.chat-phrase {
  flex: none;
  margin: 0;
  padding: 4px 12px;
  border: 1px solid #e0d4bf;
  border-radius: 15px;
  background: #fff;
  color: #2c3e50;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
}

.chat-emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}

.panel .chat-emoji-grid { grid-template-columns: repeat(auto-fill, minmax(34px, 1fr)); }

.chat-phrase, .chat-emoji { -webkit-tap-highlight-color: transparent; }

.chat-emoji {
  height: 38px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.chat-emoji:active { background: #eadfcd; }

.chat-emoji-delete {
  margin: 2px;
  height: 34px;
  border: 1px solid #ddd;
  background: #fff;
  color: #555;
  font-size: 18px;
}
</style>
